export const novemberUppercase = "cDURBd";
export default {novemberUppercase};